import Vue from 'vue';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import Popper from 'vue-popperjs';
import NpsSummary from './widgets/NpsSummary.vue';
import FieldBreakdown from './widgets/FieldBreakdown.vue';
import ConceptSummary from './widgets/ConceptSummary.vue';
import SentimentSummarySegment from './widgets/SentimentSummarySegment.vue';
import DataUtils from 'src/utils/data';
import Utils from 'src/utils/general';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { SentimentSummarySegment, NpsSummary, FieldBreakdown, ConceptSummary, Popper },
    data() {
        let topic = this.$store.getters.currentModel.topics_list[0];
        let base = {
            sentimentHelp: '<p>A summary of the sentiment scores for the data in this analysis.</p>',
            dataHelp: `
      <p>High level information about the quality of your data.</p>
      <p>An "Unusable Verbatim" is a verbatim that is either blank, or only has low frequency terms or stopwords.</p>`,
            modelHelp: '<p>High level information about the model built for this analysis.</p>',
            maxSegmentDisplay: 46,
        };
        if (topic) {
            return Object.assign(base, {
                selectedTopic: topic
            });
        }
        // No topics
        return base;
    },
    computed: {
        ...mapGetters(['currentModel', 'currentAnalysis', 'hasSentiment']),
        analysisDates() {
            return DataUtils.parseAnalysisDates(this.currentAnalysis);
        },
        analysisDate() {
            return dayjs(this.currentAnalysis.created).calendar();
        },
        firstTextField() {
            return this?.currentModel?.stats?.text_fields?.[0] || "";
        },
        numTextFields() {
            return this?.currentModel?.stats?.text_fields?.length || 0;
        },
        textFields() {
            return this?.currentModel?.stats?.text_fields?.slice(1) || [];
        },
        includedSegments() {
            return this?.currentAnalysis.included_segments || [];
        },
        excludedSegments() {
            return this?.currentAnalysis.excluded_segments || [];
        }
    },
    metaInfo() {
        return {
            title: this.currentAnalysis ? `${this.currentAnalysis.name} Summary - Kapiche` : null
        };
    },
    methods: {
        number: FormatUtils.number,
        truncate: FormatUtils.truncate,
        // Go to query results for `npsType` when nps widget is clicked.
        queryNps(npsType) {
            let queryLink = Utils.generateQueryLink([{
                    type: 'segment',
                    values: [npsType],
                    field: 'NPS Category',
                    operator: 'is'
                }]);
            this.$router.push(queryLink);
        },
        // Go to query results for `sentimentType` when sentiment widget is clicked.
        querySentiment(sentimentType) {
            let queryLink = Utils.generateQueryLink([{
                    type: 'attribute',
                    values: [sentimentType],
                    field: 'sentiment',
                    operator: 'is'
                }]);
            this.$router.push(queryLink);
        },
        roundDecimals(val) {
            return Math.round(val * 100) / 100;
        }
    }
});
